import { TooltipButton } from '@/components/ui/TooltipButton'
import { SheetTrigger } from '@/components/shadcn/sheet'
import { Button } from '@/components/shadcn/button'
import { DynamicIcon } from '@/components/icons/DynamicIcon'
import clsx from 'clsx'
import {
  StatementEditorV2Action,
  StatementEditorV2ContentDataType,
  StatementEditorV2SheetContentAction,
  StatementEditorV2SubmissionAction,
} from '../types'
import { SheetContentAction } from './SheetContentAction'
import { SubmitAction } from './SubmitAction'

export const PENDING_CONTENT_ACTION_TOOLTIP = 'Save index changes before using this action'

export function ContentBlockActions({
  actions,
  formData,
  serverActionsDisabled = false,
}: {
  actions: StatementEditorV2Action[]
  formData?: StatementEditorV2ContentDataType | Record<string, unknown>
  /** When true, actions that call the server are disabled (e.g. unsaved content from index edit mode). */
  serverActionsDisabled?: boolean
}) {
  if (!actions || actions.length === 0) return null

  return (
    <>
      {actions.map((action) => {
        if (!action.isVisible) return null
        const isDisabled = action.isDisabled || serverActionsDisabled
        const tooltip = serverActionsDisabled ? PENDING_CONTENT_ACTION_TOOLTIP : action.label
        switch (action.type) {
          case 'sheet-content': {
            const sheetContentAction = action as StatementEditorV2SheetContentAction
            const trigger = (
              <TooltipButton tooltip={tooltip}>
                <SheetTrigger asChild>
                  <Button
                    disabled={isDisabled}
                    size="icon"
                    variant="ghost"
                    className={clsx('h-6 w-6', { 'rounded-full': action.icon })}
                  >
                    {action.icon ? (
                      <DynamicIcon iconName={action.icon} />
                    ) : (
                      <span className="sr-only">{action.label}</span>
                    )}
                  </Button>
                </SheetTrigger>
              </TooltipButton>
            )
            return (
              <SheetContentAction
                key={action.id}
                action={sheetContentAction}
                trigger={trigger}
                formData={formData}
                isDisabled={isDisabled}
              />
            )
          }
          case 'submit': {
            const submissionAction = action as StatementEditorV2SubmissionAction
            return (
              <SubmitAction
                key={action.id}
                action={{ ...submissionAction, isDisabled }}
                formData={formData}
                tooltip={tooltip}
              />
            )
          }
          default:
            return null
        }
      })}
    </>
  )
}
